import { render, staticRenderFns } from "./noProject.vue?vue&type=template&id=12eb9a4d&scoped=true&"
import script from "./noProject.vue?vue&type=script&lang=js&"
export * from "./noProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb9a4d",
  null
  
)

export default component.exports